import React from 'react';
import './courseWorkSubmissionPlaceholder.module.scss';
export const CourseWorkSubmissionPlaceholder = ({ children }) => {
  return (
    <div styleName="placeholder" className="course-work-submission-placeholder">
      {children}
    </div>
  );
};
